export default () => {
  const $grid = $('.js-grid');
  window.addEventListener('keydown', (e) => {
    e = e || window.event;
    if ((e.which === 71 || e.keyCode === 71) && e.ctrlKey) {
      $grid.toggleClass('is-active');
    }
  });};
